export default __webpack_public_path__ + "ee610fd9a450b0ef775b677e1c4bf7b5.png";